import { useState } from "react";
import { X, Sparkles } from "lucide-react";
import { galleryImages } from "../mock/mock";

const GalleryPage = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div>
      <section className="pt-16 pb-12 bg-gradient-to-br from-amber-50 via-orange-50 to-yellow-50">
        <div className="container mx-auto px-4 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white shadow-sm border border-orange-100 mb-4">
            <Sparkles className="w-4 h-4 text-orange-600" />
            <span className="text-xs font-semibold text-orange-700 tracking-widest uppercase">Gallery</span>
          </div>
          <h1 className="font-display text-4xl md:text-5xl font-bold text-stone-800 mb-4">
            Moments That <span className="text-orange-600">Matter</span>
          </h1>
          <p className="text-stone-600 max-w-2xl mx-auto">A peek into the joyful world of Aadi Gayanam — learning, laughter and lots of love.</p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {galleryImages.map((img) => (
              <button
                key={img.id}
                onClick={() => setSelected(img)}
                className="group relative aspect-square rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all"
              >
                <img src={img.url} alt={img.caption} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-orange-900/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                  <p className="text-white font-semibold">{img.caption}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {selected && (
        <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={() => setSelected(null)}>
          <button className="absolute top-6 right-6 w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white hover:bg-white/40">
            <X className="w-5 h-5" />
          </button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            <img src={selected.url} alt={selected.caption} className="w-full rounded-2xl shadow-2xl" />
            <p className="text-center text-white mt-4 font-display text-xl">{selected.caption}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
